import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { PTSMasterScreen_ScreenContext } from "../ptsmasterscreen/ptsmasterscreen-context";

declare let window: any;

export interface IProjelerListesi_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProjelerListesi_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class ProjelerListesi_ScreenBase extends React.PureComponent<
  IProjelerListesi_ScreenProps,
  any
> {
  static contextType = PTSMasterScreen_ScreenContext;
  declare context: React.ContextType<typeof PTSMasterScreen_ScreenContext>;
  projelerlistesi_5810_value_kuikaSelectBoxRef: React.RefObject<any>;
  projelerlistesi_121678_value_kuikaSelectBoxRef: React.RefObject<any>;
  projelerlistesi_288403_value_kuikaSelectBoxRef: React.RefObject<any>;
  projelerlistesi_811314_value_kuikaSelectBoxRef: React.RefObject<any>;
  projelerlistesi_529766_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "868547e5-c2e8-475a-90f0-4f1c7b286a8e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 159507, PropertyName: "value", Value: "Proje Adı" },
        { Id: 5810, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 537874, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 121678, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 868011, PropertyName: "value", Value: "Durum" },
        { Id: 288403, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 273561, PropertyName: "value", Value: "Proje Yöneticis" },
        { Id: 811314, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 50157, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 431897,
          PropertyName: "startDatePlaceholder",
          Value: "Start Date",
        },
        { Id: 431897, PropertyName: "endDatePlaceholder", Value: "End Date" },
        { Id: 283770, PropertyName: "value", Value: "Projeler Listesi" },
        { Id: 564351, PropertyName: "label", Value: "Yeni Proje Oluştur" },
        {
          Id: 529766,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 721257, PropertyName: "value", Value: "#IP001" },
        {
          Id: 548831,
          PropertyName: "value",
          Value: "Villa Isı Pompası Sistemi",
        },
        { Id: 166279, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 207098, PropertyName: "value", Value: "Müşteri" },
        { Id: 340878, PropertyName: "value", Value: "Sisya Teknoloji" },
        { Id: 16280, PropertyName: "value", Value: "Müşteri" },
        { Id: 31059, PropertyName: "value", Value: "Sisya Teknoloji" },
        { Id: 517903, PropertyName: "value", Value: "Müşteri" },
        { Id: 221628, PropertyName: "value", Value: "Sisya Teknoloji" },
        { Id: 986929, PropertyName: "value", Value: "Müşteri" },
        { Id: 390423, PropertyName: "value", Value: "Sisya Teknoloji" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.projelerlistesi_5810_value_kuikaSelectBoxRef = React.createRef();
    this.projelerlistesi_121678_value_kuikaSelectBoxRef = React.createRef();
    this.projelerlistesi_288403_value_kuikaSelectBoxRef = React.createRef();
    this.projelerlistesi_811314_value_kuikaSelectBoxRef = React.createRef();
    this.projelerlistesi_529766_value_kuikaGalleryViewRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "projelerlistesi",
        "ptsmasterscreen_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "projelerlistesi",
      "ptsmasterscreen_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "projelerlistesi",
      "ptsmasterscreen_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
